var app = angular.module('directives.counters');

app.directive('counters', [
    'configs',
    '$state',
    function (configs, $state) {
        var tmplUrl;

        try {
            tmplUrl = require('../templates/' + $state.current.name.replace('pages.', '') + '.html');//looking for template with moduleName
        } catch (e) {
            tmplUrl = require('../templates/index.html')//if error(no such file), use default template
        }

        return {
            template: tmplUrl,
            controller: 'countersCtrl',
            link: function (scope, element, attrs, ctrl) {
            }
        }

    }
]);

app.controller('countersCtrl', function ($scope, Pay, Counters, configs) {
    var tariffConfig = configs.payments_config;
    $scope.pay = Pay;
    $scope.counters = Counters;
    $scope.mUnit = Counters.mUnit;
    $scope.meterUnits = Counters.meterUnits;

    $scope.checkMeterCalculator = function (serviceID, meter) {
        var isShow = false;

        for (var key in tariffConfig.energyCalc) {

            if (tariffConfig.energyCalc[key] == serviceID) {
                isShow = true;
                break;
            }
        }

        meter.calc = isShow;

        return isShow;
    };

    $scope.getCalcTariff = function (innerFn) {
        Counters.data.calcTest = innerFn;
    };
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/counters/directives/counters.js
 ** module id = 153
 ** module chunks = 1
 **/